import React, { useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { useNavigate, useParams } from "react-router-dom";

import { Col } from "react-bootstrap";

export default function TotalFamiliesRecord({ data, formState }) {
	const { t } = useContext(TranslatorContext);

	const navigate = useNavigate();

	const { key } = useParams();

	const handleCardClick = (key) => {
		formState.key = key;
		navigate(`/dashboard-count-list`, { state: formState });
		console.log("formstae data", formState);
	};

	const totalFamiliesRecord = [
		{
			key: "total_families_rescued",
			icon: "family_restroom",
			trend: "family_restroom",
			title: "Total Rescued Families",
			variant: "linear-gradient(to right, #077834, rgba(0,0,0,0.8))",
			number: data?.total_families_rescued,
			percent: 95,
		},
		{
			key: "total_male_rescued",
			icon: "male",
			trend: "male",
			title: "Total Male Rescued",
			variant: "linear-gradient(to right, #077834, rgba(0,0,0,0.8))",
			number: data?.total_male_rescued,
			percent: 30,
		},
		{
			icon: "female",

			key: "total_female_rescued",
			trend: "female",
			title: "Total Female Rescued",
			variant: "linear-gradient(to right, #077834, rgba(0,0,0,0.8))",
			number: data?.total_female_rescued,
			percent: 25,
		},
		{
			key: "total_baby_rescued",
			icon: "child_care",

			trend: "child_care",
			title: "Total Children Rescued",
			variant: "linear-gradient(to right, #077834, rgba(0,0,0,0.8))",
			number:  data?.total_children_rescued,
			percent: 45,
		},
	];
	return (
		<>
			{totalFamiliesRecord.map((data, index) => {
				return (
					<Col key={index}>
						<div
							className="mc-ecommerce-card"
							onClick={() => handleCardClick(data.key)}
							style={{
								background:
									"linear-gradient(to right, rgba(0,0,0,0.8), #077834)",
								cursor: "pointer",
							}}
						>
							<i className="mc-ecommerce-card-trend material-icons">
								{data.trend}
							</i>
							<div className="mc-ecommerce-card-head">
								<h4 className="mc-ecommerce-card-meta">
									<span>{data.title}</span>
									{data.number}
								</h4>
								<i className="mc-ecommerce-card-icon material-icons">
									{data.icon}
								</i>
							</div>
							{/* <div className="mc-ecommerce-card-foot">
								<div className="mc-ecommerce-card-compare">
									<span>{t("All The Time")}</span>
								</div>
							</div> */}
						</div>
					</Col>
				);
			})}
		</>
	);
}
